<script>
import ModelIndex from "../models/index"

export default {
  extends: ModelIndex,
  page: {
    title: "JALA Harvest",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('jala_harvests.plural')) }},
    resourceRoute: {default: 'jala_harvests'},
    modelVariable: {default: 'jala_harvest'}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('jala_harvests.plural')),
      items: [
        {
          text: this.lodash.upperFirst(this.$t('jala_harvests.plural')),
          href: "/jala_harvests",
          active: true,
        },
      ],
      filterColumns: {
        harvested_at: { type: Date, label: this.lodash.upperFirst(this.$t('jala_harvests.harvested_at')) },
      },
      sortBy: 'harvested_at',
      sortDesc: true
    }
  },
  computed: {
    columns() {
      return {
        ['jala_harvest']: [
          { key: 'index', label: '#', sortable: false, style: { width: '1%' } },
          {
            key: 'pond.farm_pond_name',
            label: this.lodash.upperFirst(this.$t('jala_harvests.pond')),
            thStyle: { minWidth: '150px' },
            sortable: true,
            component: {
              props: ['item'],
              template: '<router-link :to="`/jala_ponds/${(item.pond || {}).id}`">{{ lodash.get(item, "pond.farm_pond_name") }}</router-link>'
            }
          },
          {
            key: 'cycle.started_at',
            label: this.lodash.upperFirst(this.$t('jala_harvests.cycle')),
            thStyle: { minWidth: '150px' },
            sortable: true,
            component: {
              props: ['item'],
              template: '<router-link :to="`/jala_cycles/${(item.cycle || {}).id}`">{{ $moment(lodash.get(item, "cycle.started_at")).format(`DD MMMM YYYY`) }}</router-link>'
            }
          },
          {
            key: 'harvested_at',
            label: this.lodash.upperFirst(this.$t('jala_harvests.harvested_at')),
            thStyle: { minWidth: '200px' },
            class: 'text-center',
            sortable: true,
            formatter: (value) => {
              return this.$moment(value).format('DD MMMM YYYY');
            }
          },
          {
            key: 'weight',
            label: this.lodash.upperFirst(this.$t('jala_harvests.weight')),
            thStyle: { minWidth: '130px' },
            class: 'text-end',
            sortable: true,
            formatter: (value) => {
              return this.$numeral(value).format('0,0.[00]');
            }
          },
          {
            key: 'size',
            label: this.lodash.upperFirst(this.$t('jala_harvests.size')),
            thStyle: { minWidth: '130px' },
            class: 'text-end',
            sortable: true,
            formatter: (value) => {
              return this.$numeral(value).format('0,0.[00]');
            }
          },
          {
            key: 'selling_price',
            label: this.lodash.upperFirst(this.$t('jala_harvests.selling_price')),
            thStyle: { minWidth: '150px' },
            class: 'text-end',
            sortable: true,
            formatter: (value) => {
              return this.$numeral(value).format('0,0.[00]');
            }
          },
          {
            key: 'status',
            label: this.lodash.upperFirst(this.$t('jala_harvests.status')),
            thStyle: { minWidth: '100px' },
            sortable: true
          },
          { key: 'action', class: 'text-center', style: { width: '1%' } }
        ],
      };
    },
  },
  methods: {
    delete(value) {
      return this.$axios.delete(`/jala/harvests/${this.getModelKey(value)}`)
    },
    fetchModels(page = 1) {
      return this.$axios.get('/jala/harvests', {
        params: {
          page: page,
          per_page: this.perPage,
          search: this.search,
          sort: `${this.sortBy},${this.sortDesc ? 'desc' : 'asc'}`,
          with: 'cycle,pond.farm',
          ...this.filterParams
        }
      }).then((response) => {
        const { data: { data, meta } } = response;
        this.models = data.map((datum) => ({
          ...datum,
          _denyShow: false,
          _denyEdit: false,
          _denyDelete: false
        }))
        this.page = Number(meta.current_page);
        this.perPage = Number(meta.per_page);
        this.from = Number(meta.from);
        this.total = Number(meta.total);

        return response;
      }).catch((error) => this.failedAlert(error));
    }
  },
};
</script>
